import React from "react";
import FlexibleTable from "../../modules/FlexibleTable";
import TableCentricPage from "../../modules/TableCentricPage";

import Api from "../../utils/Api";
import TableLeftPanel from "../../utils/TableLeftPanel";
import { formatUnixTimestampTz } from "../../utils/DateTimeUtil";
import { formatBytes } from "../../utils/StringUtil";
import { useSessionStore } from "../../storez/SessionStore";
import { withToast } from "../../utils/ReactUtil";

class DiagnosticsCoredumps extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      coredumps: [],
      loaded: false,
      tzString: this.props.timezone || useSessionStore.getState().getDevice().timezone,
    };
  }

  handle_load = () => {
    let self = this;
    Api.get("/managedevice/ajax/device/coredumps", function (result) {
      const data = result["data"] ?? [];

      // parse meta-data out of file name, where available
      data.forEach((i) => {
        // new-style SphireOS standard file name:
        // <comm>.<epoch>.<pid>.<signal>.<sphireos-version>.core.gz
        const m = i["file"].match(/^.{1,15}\.(?<epoch>\d{10})\.\d{1,7}\./);
        i.dump_timestamp = m ? m.groups.epoch : undefined;
      });

      self.setState({
        coredumps: data,
        loaded: true,
      });
    });
  };

  componentDidMount() {
    this.handle_load();
  }

  render__buttons = () => {
    return <div />;
  };

  handle_Download = (file_entity) => {
    Api.get(
      "/managedevice/ajax/device/coredump/" + file_entity["file"],
      (data) => {
        window.open(data.url, "_blank");
      },
      () => {
        this.props.errorToast({
          title: "Please try again",
          description: "An unexpected error occurred while downloading the file.",
        });
      }
    );
  };

  render__content = () => {
    let self = this;
    let columns = [
      {
        title: "Upload Time",
        data: (row) => formatUnixTimestampTz(row["timestamp"], self.state.tzString),
        sortable: FlexibleTable.sortable__multi_string_field("timestamp", "file"),
        search: FlexibleTable.search__single_date_field("timestamp", self.state.tzString),
        onclick: undefined,
      },
      {
        title: "Dump Time",
        data: (row) => formatUnixTimestampTz(row["dump_timestamp"], self.state.tzString),
        sortable: FlexibleTable.sortable__multi_string_field("dump_timestamp", "file"),
        search: FlexibleTable.search__single_date_field("dump_timestamp", self.state.tzString),
        onclick: undefined,
      },
      {
        title: "Filename",
        data: function (row) {
          return row["file"];
        },
        sortable: FlexibleTable.sortable__single_caseinsensitive_string_field("file"),
        search: FlexibleTable.search__single_string_field("file"),
        onclick: undefined,
      },
      {
        title: "File Size",
        data: function (row) {
          const size = row["file_size"];
          return size == /* sic */ null || size < 0 ? "" : formatBytes(size);
        },
        sortable: FlexibleTable.sortable__single_string_field("file_size"),
        search: FlexibleTable.search__single_string_field("file_size"),
        onclick: undefined,
      },
      {
        title: "Operations",
        data: function (row) {
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          return <a onClick={() => self.handle_Download(row)}>Download</a>;
        },
        onclick: undefined,
      },
    ];

    return <FlexibleTable columns={columns} data={this.state.coredumps} loaded={this.state.loaded} sort_asc={false} sort_column={1} />;
  };

  render() {
    return (
      <TableLeftPanel>
        <TableCentricPage icon="fa fa-ban" title="Coredumps" buttons={this.render__buttons()} content={this.render__content()} />
      </TableLeftPanel>
    );
  }
}

export default withToast(DiagnosticsCoredumps);
